import { Client, IMessage } from "@stomp/stompjs";
import {
  chatRegisterDestination,
  chatSendDestination,
  chatUserTopicPrefix,
  chatWsUrl,
} from "../../config/config.js";

export const chatUserTopicPrefixPath = chatUserTopicPrefix;

export interface ClientChatSocketOptions {
  authHeader: string;
  onConnect: (client: Client) => void;
  onDisconnect?: () => void;
  onError?: (error: unknown) => void;
}

export function createClientChatSocket(options: ClientChatSocketOptions): Client {
  const { authHeader, onConnect, onDisconnect, onError } = options;

  const client = new Client({
    brokerURL: chatWsUrl,
    connectHeaders: {
      Authorization: authHeader,
      authorization: authHeader,
      accessToken: authHeader,
      token: authHeader,
      login: authHeader,
      passcode: authHeader,
    },
    reconnectDelay: 5000,
    heartbeatIncoming: 0,
    heartbeatOutgoing: 0,
    onConnect: () => onConnect(client),
    onDisconnect: () => onDisconnect?.(),
    onStompError: (frame) => {
      const headerMessage = String(frame.headers?.message ?? "").trim();
      const bodyMessage = String(frame.body ?? "").trim();
      const details = [headerMessage, bodyMessage].filter(Boolean).join(": ");
      onError?.(new Error(details || "STOMP error"));
    },
    onWebSocketError: (event) => onError?.(event),
  });

  return client;
}

export function subscribeClientTopic(
  client: Client,
  topicId: string,
  authHeader: string,
  onMessage: (message: IMessage) => void
): () => void {
  const destination = `${chatUserTopicPrefixPath}/${String(topicId || "").trim()}`;
  const subscription = client.subscribe(destination, onMessage, {
    Authorization: authHeader,
  });
  return () => subscription.unsubscribe();
}

export function registerClientUser(client: Client, uuid: string): void {
  client.publish({
    destination: chatRegisterDestination,
    headers: {
      Authorization: uuid,
    },
    body: "",
  });
}

export function sendClientMessage(client: Client, messageText: string, authHeader: string): void {
  client.publish({
    destination: chatSendDestination,
    headers: {
      Authorization: authHeader,
    },
    body: messageText,
  });
}
